module.exports = __webpack_public_path__ + "img/notes.ca23d93b.png";